import React from "react";
import S from './PrivacyPolicy.module.scss';

export const PrivacyPolicy = () => {
  return (
    <div className={S.root}>
      <div className={S.elements}>
        <h1>Политика конфиденциальности</h1>
        <div className={S.boxText}>
          <div className={S.boxParagraph}>
            <div>1. Область применения</div>
            <p>
              Настоящая политика конфиденциальности (далее — Политика) действует в отношении всей
              информации, включая персональные данные в понимании применимого законодательства РФ (далее —
              Персональная информация, или персональные данные, или ПДн), которую ООО «БМК-СОФТ», могут
              получить о вас в процессе использования вами сайта: https://bmc-soft.ru, а также в ходе
              исполнения ООО «БМК-СОФТ» любых соглашений и договоров, заключенных с Вами в связи с
              использованием Вами сайта.
              Передача Персональной информации возможна только в случаях, установленных применимым
              законодательством РФ, и осуществляется на основании специальных договоров между ООО
              «БМК-СОФТ» и каждым из Партнеров.
            </p>
          </div>
          <div className={S.boxParagraph}>
            <div>2. Общие положения</div>
            <p>Для обеспечения использования вами сайта ваша Персональная информация собирается и
              используется ООО «БМК-СОФТ», созданное по законодательству Российской Федерации, юридический
              адрес: 156000, г. Кострома, ул. Смоленская, д. 12, кв. 3, ИНН: 4400022528.</p>
          </div>
          <div className={S.boxParagraph}>
            <div>3. Принципы обработки персональных данных</div>
            <p>
              Обработка ПДн в ООО «БМК-СОФТ» основана на принципах, предусмотренных Федеральным законом от
              27.07.2006 г. № 152-ФЗ «О персональных данных», а именно:
            </p>
            <div className={S.paragraphText}>
              <p><span>1.</span> обработка ПДн осуществляется на законной и справедливой основе;</p>
              <p><span>2.</span> обработка ПДн ограничивается достижением конкретных, заранее определенных
                и законных
                целей,
                не допускается сбор ПДн, несовместимый с целями обработки ПДн;</p>
              <p><span>3.</span> не допускается объединение баз данных, содержащих ПДн, обработка которых
                осуществляется в
                целях, несовместимых между собой;</p>
              <p><span>4.</span> обработке подлежат только ПДн, которые отвечают целям их обработки;</p>
              <p><span>5.</span> содержание и объем обрабатываемых ПДн соответствуют заявленным целям
                обработки,
                обрабатываемые ПДн не избыточны по отношению к заявленным целям их обработки;</p>
              <p><span>6.</span> при обработке ПДн обеспечены точность персональных данных, их
                достаточность. ООО
                «БМК-СОФТ»
                принимает необходимые меры по удалению или уточнению неполных или неточных данных;</p>
              <p><span>7.</span> хранение ПДн осуществляется в форме, позволяющей определить субъекта
                персональных данных,
                не
                дольше, чем этого требуют цели обработки ПДн. Обрабатываемые ПДн подлежат уничтожению
                либо
                обезличиванию по достижении целей обработки или в случае утраты необходимости в
                достижении
                этих целей, если иное не предусмотрено федеральным законодательством;</p>
              <p><span>8.</span> в целях организации и контроля обработки и обеспечения безопасности ПДн,
                в ООО «БМК-СОФТ»
                назначаются ответственные лица, которые составляют основу структуры в направлении
                обработки
                ПДн.</p>
            </div>
          </div>
          <div className={S.boxParagraph}>
            <div>4. Условия и способы обработки персональных данных</div>
            <p>ООО «БМК-СОФТ»:</p>
            <p>Обработка ПДн осуществляется ООО «БМК-СОФТ» только при наличии надлежащего правового
              основания, например, с согласия субъекта ПДн на обработку его ПДн, или с целью выполнения
              договорных обязательств, когда выгодоприобретателем является субъект ПДн.</p>
            <div className={S.paragraphText}>
              <p><span>1.</span> не осуществляет обработку биометрических ПДн и специальных категорий ПДн,
                касающихся
                расовой, национальной принадлежности, политических взглядов, религиозных или философских
                убеждений;</p>
              <p><span>2.</span> не использует ПДн для принятия решений на основании исключительно их
                автоматизированной обработки, порождающих юридические последствия или иным образом
                затрагивающих права и законные интересы субъектов ПДн;</p>
              <p><span>3.</span> не осуществляет трансграничной передачи ПДн;</p>
              <p><span>4.</span> не размещает ПДн в общедоступных источниках без отдельного
                предварительного согласия в
                письменной форме субъекта ПДн;</p>
              <p><span>5.</span> не раскрывает, не передает третьим лицам и не распространяет ПДн без
                наличия
                надлежащего правового основания. ООО «БМК-СОФТ» вправе поручить обработку ПДн третьим
                лицам с согласия субъекта ПДн, если иное не предусмотрено законодательством Российской
                Федерации, на основании заключаемого с этими лицами договора (поручение оператора на
                обработку ПДн).</p>
              <p><span>6.</span> при обработке ПДн обеспечены точность персональных данных, их
                достаточность. ООО
                «БМК-СОФТ» принимает необходимые меры по удалению или уточнению неполных или неточных
                данных;</p>
              <p><span>7.</span> хранение ПДн осуществляется в форме, позволяющей определить субъекта
                персональных
                данных, не дольше, чем этого требуют цели обработки ПДн. Обрабатываемые ПДн подлежат
                уничтожению либо обезличиванию по достижении целей обработки или в случае утраты
                необходимости в достижении этих целей, если иное не предусмотрено федеральным
                законодательством;</p>
              <p><span>8.</span> в целях организации и контроля обработки и обеспечения безопасности ПДн,
                в ООО «БМК-СОФТ» назначаются ответственные лица, которые составляют основу структуры в
                направлении обработки ПДн.</p>
            </div>
            <div className={S.boxParagraph}>
              <div>ООО «БМК-СОФТ» осуществляет обработку ПДн следующими способами:</div>
              <p>с использованием средств автоматизации, в том числе с использованием информационных
                технологий и технических средств, включая средства вычислительной техники,
                информационно-технические комплексы и сети, средства и системы передачи, приема и
                обработки персональных данных, программные средства (операционные системы, системы
                управления базами данных и т.п.), средства защиты информации, применяемые в
                информационных системах;</p>
              <p>без использования средств автоматизации, когда операции по обработке ПДн, включая сбор,
                запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
                извлечение, использование, передачу (предоставление), блокирование, удаление,
                уничтожение персональных данных, осуществляются вручную.</p>
            </div>
          </div>
          <div className={S.boxParagraph}>
            <div>5. Права субъекта персональных данных</div>
            <div className={S.boxParagraph}>
              <div>Право отозвать согласие на обработку персональных данных</div>
              <p>Вы можете отозвать согласие на обработку ваших ПДн в любое время. Для этого вам
                необходимо направить в ООО «БМК-СОФТ» письменный отзыв согласия на обработку
                персональных данных с вашей личной подписью.</p>
              <p>В случае отзыва согласия, просим вас направить скан-копию оформленного отзыва на адрес
                contact@bmksoft.info. Отзыв на бумажном носителе можно передать в офис ООО «БМК-СОФТ»
                лично или отправить по почте заказным письмом с уведомлением о вручении. В срок, не
                превышающий 30 (тридцати) дней с момента поступления отзыва в письменном виде, мы
                прекратим обработку ваших ПДн и направим вам соответствующее подтверждение о прекращении
                обработки ваших ПДн.</p>
            </div>
            <div className={S.boxParagraph}>
              <div>Право на получение информации</div>
              <p>с использованием средств автоматизации, в том числе с использованием информационных
                технологий и технических средств, включая средства вычислительной техники,
                информационно-технические комплексы и сети, средства и системы передачи, приема и
                обработки персональных данных, программные средства (операционные системы, системы
                управления базами данных и т.п.), средства защиты информации, применяемые в
                информационных системах;</p>
              <div className={S.paragraphText}>
                <p><span>1.</span> подтверждение факта обработки ваших ПДн ООО «БМК-СОФТ»;</p>
                <p><span>2.</span> сведения о правовых основаниях и целях обработки ваших ПДн;</p>
                <p><span>3.</span> сведения о применяемых в ООО «БМК-СОФТ» способах обработки ПДн;</p>
                <p><span>4.</span> перечень обрабатываемых ПДн, относящихся к Вам, и информацию об
                  источнике их
                  получения, если иной порядок предоставления таких данных не предусмотрен
                  законодательством;</p>
                <p><span>5.</span> сведения о сроках обработки персональных данных, в том числе о сроках
                  их
                  хранения;</p>
                <p><span>6.</span> иные сведения, предусмотренные законодательными актами Российской
                  Федерации;</p>
              </div>
              <p>В случае запроса на получение информации, просим вас направить скан-копию запроса в
                свободной форме, содержащую собственноручную подпись, на адрес contact@bmksoft.info.
                Запрос на бумажном носителе вы можете передать в офис ООО «БМК-СОФТ» лично или отправить
                по почте заказным письмом с уведомлением о вручении. В срок, не превышающий 30
                (тридцати) дней с момента поступления отзыва в письменном виде, мы предоставим
                запрошенную информацию, касающуюся обработки Ваших персональных данных.</p>
            </div>
            <div className={S.boxParagraph}>
              <div>Право на уточнение и удаление персональных данных</div>
              <p>Вы, как субъект ПДн, имеете право:</p>
              <div className={S.paragraphText}>
                <p>требовать исправить свои ПДн, если они являются неточными, неполными или
                  устаревшими;</p>
                <p>требовать блокирования или уничтожения ваших ПДн в случае, если они являются
                  неполными, устаревшими, неточными, незаконно полученными или не являются
                  необходимыми для заявленной цели обработки ПДн;</p>
              </div>
              <p>В случае запроса на уточнение или удаление ПДн, просим вас направить скан-копию запроса в
                свободной форме, содержащую собственноручную подпись, на адрес contact@bmksoft.info.
                Запрос на бумажном носителе вы можете передать в офис ООО «БМК-СОФТ» лично или отправить
                по почте заказным письмом с уведомлением о вручении. В срок, не превышающий 7 (семи)
                рабочих дней с момента окончания проверки достоверности предоставленных сведений, мы
                выполним запрос или предоставим мотивированный отказ в выполнении запроса.</p>
              <p>В случае подтверждения неверности или неточности персональных данных, ООО «БМК-СОФТ»
                известит всех лиц, которым ранее были сообщены неверные или неточные ПДн, обо всех
                произведенных в них исключениях, исправлениях или дополнениях.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};